<template>
  <div class="media-preview">
    <!-- 多媒体列表 -->
    <div class="media-list-container">
      <div
        v-for="(media, index) in mediaList"
        :key="index"
        class="media-item-wrapper"
        :style="{ width: size + 'px' }"
      >
        <div
          class="media-item"
          :style="{ height: size + 'px' }"
          @click="showModal(index)"
        >
          <!-- 图片类型 -->
          <img
            v-if="media.type === 'image'"
            class="media-thumbnail"
            :src="media.url"
            :alt="media.name || '图片'"
          />

          <!-- 视频类型 -->
          <video
            v-else-if="media.type === 'video'"
            ref="previewVideos"
            class="media-thumbnail"
            :src="media.url"
            muted
            loop
            @mouseover="playPreview(index)"
            @mouseout="pausePreview(index)"
          ></video>
          <!-- @loadedmetadata="captureFirstFrame(index)"  -->

          <!-- 悬停遮罩层 -->
          <div class="media-mask">
            <span class="media-actions">
              <i
                class="el-icon-zoom-in action-icon"
                @click.stop="showModal(index)"
              ></i>
              <i
                v-if="isdel"
                class="el-icon-delete action-icon"
                @click.stop="handleDelete(index)"
              ></i>
            </span>
          </div>
        </div>

        <!-- 多媒体标题 -->
        <div v-if="showTitles && media.name" class="media-title">
          {{ media.name }}
        </div>
      </div>
    </div>

    <!-- 优化后的多媒体预览弹窗 -->
    <el-dialog
      :visible.sync="showModalFlag"
      :show-close="false"
      custom-class="media-dialog"
      width="45%"
      top="5vh"
      @close="handleClose"
      :append-to-body="true"
    >
      <div class="media-modal-content">
        <!-- 顶部标题栏 -->
        <div class="media-modal-header">
          <div v-if="showTitles && currentMedia.name" class="modal-media-title">
            {{ currentMedia.name }}
          </div>
          <div v-else></div>
          <i
            class="el-icon-close close-icon"
            @click="showModalFlag = false"
          ></i>
        </div>

        <!-- 内容区域 -->
        <div class="media-preview-container">
          <!-- 图片预览 -->
          <img
            v-if="currentMedia.type === 'image'"
            class="media-preview-content"
            :src="currentMedia.url"
            :alt="currentMedia.name || '图片'"
          />

          <!-- 视频预览 -->
          <video
            v-else-if="currentMedia.type === 'video'"
            ref="modalVideo"
            class="media-preview-content"
            :src="currentMedia.url"
            controls
            autoplay
          ></video>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "OptimizedMediaPreview",
  props: {
    mediaList: {
      type: Array,
      required: true,
      default: () => [],
      validator: (value) => {
        return value.every(
          (item) => item.url && ["image", "video"].includes(item.type)
        );
      },
    },
    size: {
      type: Number,
      default: 120,
    },
    showTitles: {
      type: Boolean,
      default: false,
    },
    isdel: {
      type: Boolean,
      default: true,
    },
    // 弹窗最小高度
    minHeight: {
      type: Number,
      default: 400,
    },
    // 弹窗最小宽度
    minWidth: {
      type: Number,
      default: 600,
    },
  },
  data() {
    return {
      showModalFlag: false,
      currentMediaIndex: -1,
      canvasList: [],
    };
  },
  computed: {
    currentMedia() {
      return this.mediaList[this.currentMediaIndex] || {};
    },
  },
  methods: {
    captureFirstFrame(index) {
      if (this.mediaList[index].type !== "video") return;

      if (!this.canvasList[index]) {
        this.canvasList[index] = document.createElement("canvas");
      }

      const video = this.$refs.previewVideos[index];
      const canvas = this.canvasList[index];

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      video.pause();
      video.poster = canvas.toDataURL("image/jpeg");
    },
    playPreview(index) {
      if (this.mediaList[index].type === "video") {
        this.$refs.previewVideos[index].play();
      }
    },
    pausePreview(index) {
      if (this.mediaList[index].type === "video") {
        this.$refs.previewVideos[index].pause();
      }
    },
    showModal(index) {
      this.currentMediaIndex = index;
      this.showModalFlag = true;
    },
    handleClose() {
      if (this.currentMedia.type === "video") {
        this.$refs.modalVideo.pause();
      }
      this.currentMediaIndex = -1;
    },
    handleDelete(index) {
      this.$confirm("确定要删除此项吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.mediaList.splice(index, 1);
          // this.$emit('delete', index)
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.media-preview {
  /* width: 100%; */
  margin-right: 20px;
}

.media-list-container {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.media-item-wrapper {
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
}

.media-item {
  position: relative;
  width: 100%;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
  border: 1px solid #ebeef5;
  background-color: #f5f7fa;
  cursor: pointer;
}

.media-item:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.media-thumbnail {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.media-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  cursor: default;
}

.media-item:hover .media-mask {
  opacity: 1;
}

.media-actions {
  display: flex;
  justify-content: space-around;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
}

.action-icon {
  font-size: 18px;
  cursor: pointer;
  transition: all 0.3s;
}

.action-icon:hover {
  color: #409eff;
  transform: scale(1.2);
}

.media-title {
  margin-top: 6px;
  font-size: 13px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
  padding: 0 4px;
}

/* 弹窗内容样式 */
.media-modal-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.media-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding: 0 8px;
}

.modal-media-title {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 12px;
}

.close-icon {
  font-size: 20px;
  color: #909399;
  cursor: pointer;
  transition: color 0.3s;
}

.close-icon:hover {
  color: #409eff;
}

.media-preview-container {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60%;
  /* min-height: v-bind('minHeight + "px"');
  min-width: v-bind('minWidth + "px"'); */
  background-color: #f5f7fa;
  border-radius: 4px;
  overflow: hidden;
}

.media-preview-content {
  width: 100%;
  height: 100%;

  display: block;
  object-fit: contain;
}
</style>

<style>
/* 弹窗全局样式 */
.media-dialog {
  border-radius: 8px;
  overflow: hidden;
}

.media-dialog .el-dialog__header {
  display: none;
}

.media-dialog .el-dialog__body {
  padding: 20px;
  background-color: #fff;
  height: calc(100% - 40px);
  display: flex;
  flex-direction: column;
}
</style>
